import { Flex, Heading, Text, Button, Icon, Spinner } from "@chakra-ui/react";
import { DownloadIcon, WarningIcon } from "@chakra-ui/icons";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import OrdersService from "../../api/services/OrdersService";

const TicketDownloadPage = () => {
    const { t } = useTranslation("default");
    const navigate = useNavigate();
    const { id } = useParams();
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");

    const [status, setStatus] = useState("loading"); // loading, success, error

    const downloadTicket = async () => {
        try {
            setStatus("loading");
            await OrdersService.downloadTicket(id, token);
            setStatus("success");
        } catch (error) {
            console.error("Failed to download ticket", error);
            setStatus("error");
        }
    };

    useEffect(() => {
        if (id && token) {
            downloadTicket();
        } else {
            setStatus("error");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Flex
            flexDirection="column"
            w="100%"
            alignItems="center"
            justifyContent="center"
            bg="white"
            py={{ base: "60px", md: "120px" }}
            px={{ base: "16px", md: "32px" }}
            minH="60vh"
        >
            <Flex
                flexDirection="column"
                alignItems="center"
                maxW="600px"
                textAlign="center"
                gap={6}
            >
                {status === "loading" && (
                    <>
                        <Spinner size="xl" color="#7A1F35" thickness="4px" />
                        <Heading as="h1" size="xl" color="#1E1517" fontFamily="body">
                            {t("ticket.download.loading_title")}
                        </Heading>
                        <Text fontSize="lg" color="#6E6064" fontFamily="body" maxW="400px">
                            {t("ticket.download.loading_desc")}
                        </Text>
                    </>
                )}

                {status === "success" && (
                    <>
                        {/* Ikona check circle – SVG z brandingiem evenado */}
                        <svg width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="48" cy="48" r="48" fill="#7A1F35" />
                            <path d="M28 50L42 64L68 36" stroke="white" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        <Heading as="h1" size="xl" color="#1E1517" fontFamily="body" fontWeight="800">
                            {t("ticket.download.ready_title")}
                        </Heading>
                        <Flex gap={4} mt={4} flexWrap="wrap" justifyContent="center">
                            <Button
                                bg="#7A1F35"
                                color="white"
                                px={8}
                                py={6}
                                borderRadius="full"
                                fontFamily="body"
                                fontWeight="bold"
                                _hover={{ bg: "#5C1628" }}
                                leftIcon={<DownloadIcon />}
                                onClick={downloadTicket}
                            >
                                {t("ticket.download.download_btn")}
                            </Button>
                            <Button
                                bg="transparent"
                                color="#7A1F35"
                                border="2px solid #7A1F35"
                                px={8}
                                py={6}
                                borderRadius="full"
                                fontFamily="body"
                                fontWeight="bold"
                                _hover={{ bg: "#F8F5F4" }}
                                onClick={() => navigate("/")}
                            >
                                {t("ticket.download.home_btn")}
                            </Button>
                        </Flex>
                    </>
                )}

                {status === "error" && (
                    <>
                        <Icon as={WarningIcon} w={24} h={24} color="#E53E3E" />
                        <Heading as="h1" size="xl" color="#1E1517" fontFamily="body">
                            {t("ticket.download.error_title")}
                        </Heading>
                        <Text fontSize="lg" color="#6E6064" fontFamily="body" maxW="400px">
                            {t("ticket.download.error_desc")}
                        </Text>
                        <Flex gap={4} mt={4} flexWrap="wrap" justifyContent="center">
                            <Button
                                bg="#7A1F35"
                                color="white"
                                px={8}
                                py={6}
                                borderRadius="full"
                                fontFamily="body"
                                fontWeight="bold"
                                _hover={{ bg: "#5C1628" }}
                                leftIcon={<DownloadIcon />}
                                onClick={downloadTicket}
                            >
                                {t("ticket.download.retry_btn")}
                            </Button>
                            <Button
                                bg="transparent"
                                color="#7A1F35"
                                border="2px solid #7A1F35"
                                px={8}
                                py={6}
                                borderRadius="full"
                                fontFamily="body"
                                fontWeight="bold"
                                _hover={{ bg: "#F8F5F4" }}
                                onClick={() => navigate("/")}
                            >
                                {t("ticket.download.home_btn")}
                            </Button>
                        </Flex>
                    </>
                )}
            </Flex>
        </Flex>
    );
};

export default TicketDownloadPage;
